/**
 * Created by Ko-Hsin on 16/05/2018.
 */

import { Component,ViewEncapsulation } from '@angular/core';
import {AuthService} from "../../../core/auth.service";
import {AngularFirestoreDocument} from "angularfire2/firestore/document/document";
import {AngularFirestore} from "angularfire2/firestore/firestore";
import {User} from "../../../core/core.model";

@Component({
    selector: 'user-details',
    template: `
<div>
    <div *ngIf="auth.user | async as user" class="flex justify-between items-center account">
        <div class="user" >
            <img *ngIf="user.photoURL" class="profile_image" [src]="user.photoURL">
            <div *ngIf="!user.photoURL"  class="initials rounded-full" [textContent]="user.displayName | initials"></div>
            <div>
                <div class="edit_name" *ngIf="display_form">
                    <div  class="profile" [ngClass]="{loading:loading}">
                        <label for="firstName">First name</label>
                        <mat-form-field >
                            <input matInput id="firstName" name="firstName" required [(ngModel)]="firstName">
                        </mat-form-field>
                        <label for="lastName">Last name</label>
                        <mat-form-field >
                            <input matInput id="lastName" name="lastName" required [(ngModel)]="lastName">
                        </mat-form-field>
                        <div>
                            <button (click)="save()">Save changes</button>
                            <button (click)="cancel()">Cancel</button>
                        </div>
                    </div>
                </div>
                <div class="name cursor-pointer" *ngIf="!display_form" (click)="display_form = true">{{ user.displayName }} <mat-icon class="edit_btn">edit</mat-icon></div>
                <div class="email">{{user.email}}</div>
            </div>
        </div>
        <button *ngIf="!user.providerData">Change password</button>
    </div>
</div>
    `,
    styles: [`
        
    .profile_image {height: 36px; width: 36px; border-radius: 50px} 
    .profile { display: flex; flex-direction: column; padding-left: 10px; 	margin-bottom: 30px;}
    .profile label { font-size: 12px; color: #999; position: relative; top: 10px; }
    .profile.loading { opacity: .5; }
    .account { display: flex}
    .account .data {font-size: 14px; color: #999; margin-right: 10px; }
    .account .data span { color: #fff; } 
    .account .user { display:flex; }
    .account .name { font-size: 20px;  font-weight: 300; margin: 0 20px 0 10px; }
    .account .name .edit_btn { display:none; height: 15px; width: 15px; font-size: 15px; }
    .account .name:hover .edit_btn { display:inline-block; }
    .account  .email { font-size: 13px; color: #666; font-weight: 100; margin: 2px 20px 0 10px; }
    .initials  { width: 40px; line-height: 40px; text-align: center; color: #fff; background: #ffbb0b;}

    `],
    encapsulation: ViewEncapsulation.None
})
export class UserDetailsComponent {
    firstName
    lastName
    uid;
    display_form:boolean = false;
    loading:boolean = false;

    constructor(public auth:AuthService, public afs:AngularFirestore){
        this.auth.user.subscribe(user => {
            this.firstName = user['firstName'];
            this.lastName = user['lastName'];
            this.uid = user['uid'];
        })
    }

    formHandler(){

    }

    save(){
        if(this.loading) return;
        this.loading = true;
        const displayName = this.firstName + ' ' + this.lastName;
        const userDoc: AngularFirestoreDocument<any> = this.afs.doc(`users/${this.uid}`);
        const data: User = {} as User;
        if (this.firstName) data['firstName'] = this.firstName;
        if (this.lastName) data['lastName'] = this.lastName;
        if (displayName) data['displayName'] = displayName;
        console.log('save ', data, this.firstName, this.lastName, this.uid);
        userDoc.set(data, { merge: true }).then(_=>{
            this.loading = false;
            this.display_form = false;
        })
    }

    cancel(){
        if(this.loading) return;
        this.display_form = false;
    }

}


// WEBPACK FOOTER //
// ./src/app/pages/account/components/user-details.ts